import { render } from "./PopupTechnicalWork.vue?vue&type=template&id=4284ccc8&scoped=true"
import script from "./PopupTechnicalWork.vue?vue&type=script&lang=js"
export * from "./PopupTechnicalWork.vue?vue&type=script&lang=js"

import "./PopupTechnicalWork.vue?vue&type=style&index=0&id=4284ccc8&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4284ccc8"]])

export default __exports__